import CalendarEvent from 'mini-calendar-event-types/lib/MiniCalendarEvent';
import formatMeetingTimeSpan from 'owa-timeformat/lib/utils/formatMeetingTimeSpan';
import MeetingMessage from 'owa-service/lib/contract/MeetingMessage';
import { format } from 'owa-strings';
import { getEventTypeString } from './getEventTypeString';
import { getOwaMiniCommonStrings } from 'owa-strings/owa-mini-common-strings';
import { isCurrentUserTheMailSender } from 'mini-meeting-invite/lib/utils/isCurrentUserTheMailSender';

/**
 * For a item which represents an attendee response this shows the subtitle
 * @param item
 * @param emailSender
 */
export const getRsvpUnitSubtitleForAttendee = (
    item: CalendarEvent,
    originalMeetingMessage?: MeetingMessage
) => {
    const strings = getOwaMiniCommonStrings();

    const eventType = getEventTypeString(item);

    const { ResponseType, ProposedNewTimeStart, ProposedNewTimeEnd } = item;

    const emailSender = originalMeetingMessage?.Sender?.Mailbox;

    const isCurrentUserSender = isCurrentUserTheMailSender(emailSender);

    if (ProposedNewTimeStart && ProposedNewTimeEnd) {
        const newTime: string = formatMeetingTimeSpan(
            ProposedNewTimeStart,
            ProposedNewTimeEnd,
            undefined /** recurrence */,
            true /**isShortString */
        );

        if (isCurrentUserSender) {
            return format(
                ResponseType === 'Tentative'
                    ? strings.youTentativeProposeNewTimeEventFormatString
                    : strings.youDeclinedProposeNewTimeEventFormatString,
                eventType,
                newTime
            );
        }

        const actorName = emailSender?.Name || emailSender?.EmailAddress;

        return format(
            ResponseType === 'Tentative'
                ? strings.tentativeProposeNewTimeEventFormatString
                : strings.declinedProposeNewTimeEventFormatString,
            actorName,
            eventType,
            newTime
        );
    } else {
        const actorName = emailSender?.Name || emailSender?.EmailAddress;

        switch (ResponseType) {
            case 'Accept':
                return isCurrentUserSender
                    ? format(strings.youAcceptedEventFormatString, eventType)
                    : format(strings.acceptedEventFormatString, actorName, eventType);
            case 'Tentative':
                return isCurrentUserSender
                    ? format(strings.youTentativeEventFormatString, eventType)
                    : format(strings.tentativeEventFormatString, actorName, eventType);
            case 'Decline':
                return isCurrentUserSender
                    ? format(strings.youDeclinedEventFormatString, eventType)
                    : format(strings.declinedEventFormatString, actorName, eventType);
        }
    }

    return '';
};
